// Types de pièces du coffre (mêmes clés que backend/services/procedures.py DOC_TYPES)
export const DOC_TYPES = {
  piece_identite: { label: "Pièce d'identité", category: 'identite' },
  titre_sejour: { label: 'Titre de séjour', category: 'identite' },
  justificatif_domicile: { label: 'Justificatif de domicile (moins de 3 mois)', category: 'logement' },
  bail: { label: 'Contrat de bail', category: 'logement' },
  quittance_loyer: { label: 'Quittance de loyer', category: 'logement' },
  attestation_loyer: { label: 'Attestation de loyer (remplie par le bailleur)', category: 'logement' },
  rib: { label: 'RIB', category: 'banque' },
  bulletin_paie: { label: 'Bulletin de paie', category: 'travail' },
  contrat_travail: { label: 'Contrat de travail', category: 'travail' },
  avis_imposition: { label: "Avis d'imposition", category: 'impots' },
  attestation_france_travail: { label: 'Attestation France Travail', category: 'travail' },
  certificat_scolarite: { label: 'Certificat de scolarité', category: 'autre' },
};
